import { Col, Row } from "reactstrap";

const Especificaciones = () => {
  return (
    <div className="p-5">
      <table width="100%" border="0" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td class="espec">Eje de seguimiento:</td>
            <td class="espec">Azimutal (este-oeste)</td>

            <td class="espec">Modulos aceptados:</td>
            <td class="espec">Todos los comerciales</td>
          </tr>
          <tr>
            <td class="espec2">Inclinación norte-sur:</td>
            <td class="espec2">15°</td>

            <td class="espec2">Potencia admitida:</td>
            <td class="espec2">Hasta 32000Wp</td>
          </tr>
          <tr>
            <td class="espec">Angulo de giro:</td>
            <td class="espec">90° (45° Este a 45° Oeste)</td>

            <td class="espec">Tensión de servicio:</td>
            <td class="espec">380V AC (220V AC)</td>
          </tr>
          <tr>
            <td class="espec2">Estructura modular:</td>
            <td class="espec2">Hasta 22 filas de 8 módulos</td>

            <td class="espec2">Motorización:</td>
            <td class="espec2">1 Actuador Lineal 10TN</td>
          </tr>
          <tr>
            <td class="espec">Dimensiones máximas:</td>
            <td class="espec">66 x 7m</td>

            <td class="espec">Motor:</td>
            <td class="espec">1CV Trifásico</td>
          </tr>
          <tr>
            <td class="espec2">Superfície paneles:</td>
            <td class="espec2">Hasta 224m2</td>

            <td class="espec2">Materiales estructura:</td>
            <td class="espec2">
              Acero galvanizado Tornillería en acero inoxidable
            </td>
          </tr>
          <tr>
            <td class="espec">Altura máxima:</td>
            <td class="espec">2800mm mas cimentación</td>

            <td class="espec">Sujecion módulos:</td>
            <td class="espec">útiles especiales en aluminio</td>
          </tr>
          <tr>
            <td class="espec2">Parrilla de módulos</td>
            <td class="espec2">2 filas de 6m por bloque</td>

            <td class="espec2">Cimentación:</td>
            <td class="espec2">Bloque Hormigón o Anclaje metálico al suelo.</td>
          </tr>
          <tr>
            <td colspan="5" class="espec">
              Armarios electrónica y conexionado metálicos estancos.
              Precableados. Incluyen fuente alimentación{" "}
            </td>
          </tr>
          <tr>
            <td colspan="5" class="espec2">
              Tecnología seguimiento con cálculo de coordenadas por
              microprocesador
            </td>
          </tr>
          <tr>
            <td colspan="5" class="espec">
              Posición nocturna “parking” horizontal
            </td>
          </tr>
          <tr>
            <td colspan="5" class="espec2">
              Sensor de viento programable. A cierta velocidad se coloca en
              posición horizontal
            </td>
          </tr>
          <tr>
            <td colspan="5" class="espec">
              Sistema “Backtraking”. Evita sombras entre módulos.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default Especificaciones;
